<template>
  <div>
    <header id="cdfsolo8-header" :class="headerClass">
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@500;600;700;800&display=swap"
      />

      <div class="cdfsolo8-inner">
        <a
          href="https://calculadoradefletes.com/"
          class="cdfsolo8-brand"
          aria-label="Ir al inicio de Calculadora de Fletes"
        >
          <img
            src="https://calculadoradefletes.com/wp-content/uploads/2026/08/Logo-CalculadoradeFletes.webp"
            class="cdfsolo8-logo cdfsolo8-logo-light"
            alt="Ir al Home"
            loading="eager"
            decoding="async"
          />

          <img
            src="https://calculadoradefletes.com/wp-content/uploads/2026/08/Logo-Calculadora.webp"
            class="cdfsolo8-logo cdfsolo8-logo-dark"
            alt="Ir al Home"
            loading="eager"
            decoding="async"
          />
        </a>

        <a
          href="#"
          class="cdfsolo8-contact cdfhdrx-wa-launch cdf-contact-button"
          aria-haspopup="dialog"
          aria-controls="cdfhdrx-wa-modal"
          aria-label="Elegir un asesor por WhatsApp"
          @click.prevent="abrirWhatsApp"
        >
          <span class="cdfsolo8-wa" aria-hidden="true">
            <svg viewBox="0 0 448 512">
              <path
                d="M380.9 97.1C339 55.1 283.2 32 223.9 32 101.5 32 1.9 131.6 1.9 254c0 44.3 11.6 87.5 33.7 125.5L0 480l103.4-34.2c36.7 20.1 78 30.7 120.3 30.7h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.1-115-67-157.4zM223.9 438.7c-37.6 0-74.4-10.1-106.4-29.2l-7.4-4.4-61.4 20.3 20.6-59.8-4.8-7.7c-20.9-33.3-31.9-71.7-31.9-111.4 0-105.2 85.6-190.8 191-190.8 51 0 98.9 19.9 134.9 56 36 36.2 55.8 84.2 55.7 135.2-.1 105.2-85.8 190.9-190.3 190.9zm104.7-141.6c-5.7-2.8-33.8-16.6-39-18.5-5.2-1.9-9-2.8-12.8 2.8-3.8 5.7-14.7 18.5-18 22.3-3.3 3.8-6.6 4.3-12.3 1.4-33.6-16.8-55.7-30-77.9-68-5.9-10.2 5.9-9.5 16.8-31.7 1.9-3.8 1-7.1-.5-9.9-1.4-2.8-12.8-30.9-17.5-42.4-4.6-11.1-9.4-9.6-12.8-9.8-3.3-.2-7.1-.2-10.9-.2-3.8 0-9.9 1.4-15.2 7.1-5.2 5.7-19.9 19.5-19.9 47.6 0 28 20.4 55.2 23.2 59 2.8 3.8 40.1 61.2 97.1 85.8 36.1 15.6 50.2 16.9 68.2 14.2 10.9-1.6 33.8-13.8 38.6-27.1 4.8-13.3 4.8-24.7 3.3-27.1-1.3-2.5-5.1-3.8-10.8-6.6z"
              />
            </svg>
          </span>

          <span>Contáctanos</span>

          <span class="cdfsolo8-arrow" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M5 12h14"></path>
              <path d="m14 7 5 5-5 5"></path>
            </svg>
          </span>
        </a>
      </div>
    </header>

    <div
      id="cdfhdrx-wa-modal"
      ref="whatsappModal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cdfhdrx-wa-modal-title"
      aria-describedby="cdfhdrx-wa-modal-description"
      :aria-hidden="modalWhatsApp ? 'false' : 'true'"
      :class="{ 'cdfhdrx-modal-open': modalWhatsApp }"
    >
      <div
        class="cdfhdrx-modal-backdrop"
        @click="cerrarWhatsApp"
        aria-hidden="true"
      ></div>

      <div class="cdfhdrx-modal-dialog" role="document">
        <button
          type="button"
          class="cdfhdrx-modal-close"
          aria-label="Cerrar selección de asesores"
          @click="cerrarWhatsApp"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 6l12 12"></path>
            <path d="M18 6L6 18"></path>
          </svg>
        </button>

        <p class="cdfhdrx-modal-kicker">ATENCIÓN PERSONALIZADA POR WHATSAPP</p>

        <h2 class="cdfhdrx-modal-title" id="cdfhdrx-wa-modal-title">
          Elige con qué equipo deseas hablar
        </h2>

        <p class="cdfhdrx-modal-description" id="cdfhdrx-wa-modal-description">
          Te atenderá directamente el equipo correspondiente a tu ubicación.
        </p>

        <div class="cdfhdrx-country-grid">
          <a
            href="https://api.whatsapp.com/send?phone=51906931842&amp;text=Hola%20visit%C3%A9%20https://calculadoradefletes.com%20me%20gustar%C3%ADa%20m%C3%A1s%20informaci%C3%B3n%20sobre%20sus%20servicios."
            target="_blank"
            rel="noopener noreferrer"
            class="cdfhdrx-country-card cdfhdrx-country-card--peru"
            aria-label="Hablar por WhatsApp con un asesor de Perú"
          >
            <span class="cdfhdrx-country-shine" aria-hidden="true"></span>

            <span class="cdfhdrx-country-info">
              <span class="cdfhdrx-country-icon" aria-hidden="true">
                <img
                  src="https://www.pic-cargo.com/wp-content/uploads/2025/08/transporte-maritimo-pic-cargo.svg"
                  alt=""
                />
              </span>

              <span class="cdfhdrx-country-name">PERÚ</span>

              <span class="cdfhdrx-country-icon" aria-hidden="true">
                <img
                  src="https://www.pic-cargo.com/wp-content/uploads/2025/08/transporte-maritimo-pic-cargo.webp"
                  alt=""
                />
              </span>

              <span class="cdfhdrx-country-phone">+51 906 931 842</span>
            </span>
          </a>

          <a
            href="https://api.whatsapp.com/send?phone=50767280364&amp;text=Hola%20visit%C3%A9%20https://calculadoradefletes.com%20me%20gustar%C3%ADa%20m%C3%A1s%20informaci%C3%B3n%20sobre%20sus%20servicios."
            target="_blank"
            rel="noopener noreferrer"
            class="cdfhdrx-country-card cdfhdrx-country-card--panama"
            aria-label="Hablar por WhatsApp con un asesor de Panamá"
          >
            <span class="cdfhdrx-country-shine" aria-hidden="true"></span>

            <span class="cdfhdrx-country-info">
              <span class="cdfhdrx-country-icon" aria-hidden="true">
                <img
                  src="https://www.pic-cargo.com/wp-content/uploads/2025/08/transporte-maritimo-pic-cargo-1.svg"
                  alt=""
                />
              </span>

              <span class="cdfhdrx-country-name">PANAMÁ</span>

              <span class="cdfhdrx-country-icon" aria-hidden="true">
                <img
                  src="https://www.pic-cargo.com/wp-content/uploads/2025/08/transporte-maritimo-pic-cargo.webp"
                  alt=""
                />
              </span>

              <span class="cdfhdrx-country-phone">+507 6728-0364</span>
            </span>
          </a>

          <a
            href="https://api.whatsapp.com/send?phone=584223100595&amp;text=Hola%20visit%C3%A9%20https://calculadoradefletes.com%20me%20gustar%C3%ADa%20m%C3%A1s%20informaci%C3%B3n%20sobre%20sus%20servicios."
            target="_blank"
            rel="noopener noreferrer"
            class="cdfhdrx-country-card cdfhdrx-country-card--venezuela"
            aria-label="Hablar por WhatsApp con un asesor de Venezuela"
          >
            <span class="cdfhdrx-country-shine" aria-hidden="true"></span>

            <span class="cdfhdrx-country-info">
              <span class="cdfhdrx-country-icon" aria-hidden="true">
                <img
                  src="https://www.pic-cargo.com/wp-content/uploads/2025/08/transporte-maritimo-pic-cargo-2-1.svg"
                  alt=""
                />
              </span>

              <span class="cdfhdrx-country-name">VENEZUELA</span>

              <span class="cdfhdrx-country-icon" aria-hidden="true">
                <img
                  src="https://www.pic-cargo.com/wp-content/uploads/2025/08/transporte-maritimo-pic-cargo.webp"
                  alt=""
                />
              </span>

              <span class="cdfhdrx-country-phone">+58 422 310 0595</span>
            </span>
          </a>
        </div>
      </div>
    </div>

    <div id="cdfsolo8-header-space" aria-hidden="true"></div>
  </div>
</template>

<script>
export default {
  name: "HeaderComponent",

  data() {
    return {
      headerClass: "cdfsolo8-top",

      anteriorScroll: 0,
      ticking: false,

      zonaTop: 6,
      tolerancia: 4,

      modalWhatsApp: false,
      lastFocusedElement: null,
    };
  },

  mounted() {
    this.anteriorScroll = this.scrollActual();

    this.actualizarEstadoHeader();
    this.$root.$on("abrir-contacto-whatsapp", this.abrirWhatsApp);

    window.addEventListener("scroll", this.alScroll, {
      passive: true,
    });

    window.addEventListener("pageshow", this.alPageshow, {
      passive: true,
    });

    document.addEventListener("keydown", this.alKeydown);
  },

  beforeDestroy() {
    this.$root.$off("abrir-contacto-whatsapp", this.abrirWhatsApp);

    window.removeEventListener("scroll", this.alScroll);

    window.removeEventListener("pageshow", this.alPageshow);

    document.removeEventListener("keydown", this.alKeydown);

    document.body.classList.remove("cdfhdrx-scroll-lock");
  },

  methods: {
    // ==========================================
    // HEADER / SCROLL
    // ==========================================

    scrollActual() {
      return Math.max(
        window.scrollY || 0,
        document.documentElement.scrollTop || 0,
        0,
      );
    },

    estadoHeader(clase) {
      this.headerClass = clase;
    },

    actualizarEstadoHeader() {
      const actual = this.scrollActual();

      const diferencia = actual - this.anteriorScroll;

      if (actual <= this.zonaTop) {
        this.estadoHeader("cdfsolo8-top");
      } else if (Math.abs(diferencia) >= this.tolerancia) {
        if (diferencia > 0) {
          this.estadoHeader("cdfsolo8-hidden");
        } else {
          this.estadoHeader("cdfsolo8-white");
        }
      }

      this.anteriorScroll = actual;
      this.ticking = false;
    },

    alScroll() {
      if (this.ticking) {
        return;
      }

      this.ticking = true;

      window.requestAnimationFrame(() => {
        this.actualizarEstadoHeader();
      });
    },

    alPageshow() {
      this.anteriorScroll = this.scrollActual();

      this.estadoHeader(
        this.anteriorScroll <= this.zonaTop ? "cdfsolo8-top" : "cdfsolo8-white",
      );
    },

    // ==========================================
    // MODAL WHATSAPP
    // ==========================================

    abrirWhatsApp() {
      this.lastFocusedElement = document.activeElement;

      this.modalWhatsApp = true;

      document.body.classList.add("cdfhdrx-scroll-lock");

      this.$nextTick(() => {
        const focusable = this.getFocusableElements();

        if (focusable.length) {
          focusable[0].focus();
        }
      });
    },

    cerrarWhatsApp() {
      this.modalWhatsApp = false;

      document.body.classList.remove("cdfhdrx-scroll-lock");

      if (
        this.lastFocusedElement &&
        typeof this.lastFocusedElement.focus === "function"
      ) {
        this.lastFocusedElement.focus();
      }
    },

    getFocusableElements() {
      if (!this.$refs.whatsappModal) {
        return [];
      }

      return Array.from(
        this.$refs.whatsappModal.querySelectorAll(
          'a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])',
        ),
      );
    },

    alKeydown(event) {
      if (!this.modalWhatsApp) {
        return;
      }

      // ESC
      if (event.key === "Escape") {
        event.preventDefault();

        this.cerrarWhatsApp();

        return;
      }

      // TAB
      if (event.key === "Tab") {
        const focusable = this.getFocusableElements();

        if (!focusable.length) {
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();

          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();

          first.focus();
        }
      }
    },
  },
};
</script>

<style>
#cdfsolo8-header,
#cdfsolo8-header *,
#cdfsolo8-header *::before,
#cdfsolo8-header *::after {
  box-sizing: border-box;
}

#cdfsolo8-header {
  --cdfsolo8-font: "Montserrat", system-ui, -apple-system, "Segoe UI", Roboto,
    Arial, sans-serif;
  --cdfsolo8-navy: #031f33;
  --cdfsolo8-blue: #0798e8;
  --cdfsolo8-orange: #f77a00;
  --cdfsolo8-orange-dark: #eb6800;
  --cdfsolo8-white: #ffffff;

  width: 100% !important;
  max-width: 100% !important;

  height: 86px !important;
  min-height: 86px !important;

  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;

  z-index: 999999 !important;

  margin: 0 !important;
  padding: 0 !important;

  font-family: var(--cdfsolo8-font);

  overflow: visible !important;

  will-change: transform;
  transform: translate3d(0, 0, 0);

  transition: transform 0.26s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease,
    background-color 0.22s ease, box-shadow 0.22s ease;
}

body.admin-bar #cdfsolo8-header:not(.cdfsolo8-editor) {
  top: 32px !important;
}

@media (max-width: 782px) {
  body.admin-bar #cdfsolo8-header:not(.cdfsolo8-editor) {
    top: 46px !important;
  }
}

#cdfsolo8-header.cdfsolo8-top {
  background: linear-gradient(
    108deg,
    #021a2b 0%,
    #03243a 34%,
    #063651 72%,
    #052a42 100%
  ) !important;

  border-bottom: 1px solid rgba(73, 182, 244, 0.25) !important;

  box-shadow: 0 8px 22px rgba(1, 20, 33, 0.18) !important;
}

#cdfsolo8-header.cdfsolo8-top::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  pointer-events: none;

  background: linear-gradient(
    90deg,
    #087ec3 0%,
    #1db3f4 42%,
    #43c7ff 52%,
    #159dde 75%,
    #087ec3 100%
  );
}

#cdfsolo8-header.cdfsolo8-white {
  background: #ffffff !important;

  border-bottom: 1px solid rgba(7, 50, 79, 0.08) !important;

  box-shadow: 0 8px 22px rgba(7, 41, 63, 0.09) !important;
}

#cdfsolo8-header.cdfsolo8-white::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  pointer-events: none;

  background: linear-gradient(
    90deg,
    transparent,
    rgba(7, 151, 229, 0.42),
    transparent
  );
}

#cdfsolo8-header.cdfsolo8-hidden {
  transform: translate3d(0, -140%, 0) !important;
  opacity: 0 !important;
  pointer-events: none !important;
  box-shadow: none !important;
}

#cdfsolo8-header .cdfsolo8-inner {
  width: min(calc(100% - 72px), 1480px);

  height: 86px;
  min-height: 86px;

  position: relative;
  z-index: 2;

  margin: 0 auto !important;
  padding: 0 !important;

  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 24px;
}

#cdfsolo8-header .cdfsolo8-brand {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;

  flex: 0 1 auto;

  min-width: 0;

  position: relative;

  margin: 0 !important;
  padding: 0 !important;

  text-decoration: none;

  background: transparent !important;
  border: 0 !important;
}

#cdfsolo8-header .cdfsolo8-brand::after {
  content: "";

  position: absolute;

  left: 0;
  bottom: 3px;

  width: 60%;
  height: 3px;

  border-radius: 999px;

  background: linear-gradient(90deg, #f77a00 0%, #16a8ee 58%, #43c7ff 100%);

  transform: scaleX(0);
  transform-origin: left center;

  opacity: 0;

  transition: transform 0.22s ease, opacity 0.22s ease;
}

#cdfsolo8-header .cdfsolo8-brand:hover::after,
#cdfsolo8-header .cdfsolo8-brand:focus-visible::after {
  transform: scaleX(1);
  opacity: 1;
}

#cdfsolo8-header .cdfsolo8-logo {
  width: 325px;
  height: 66px;

  display: block;

  max-width: 100%;

  object-fit: contain;
  object-position: left center;

  border: 0 !important;
  box-shadow: none !important;

  transition: transform 0.18s ease, filter 0.18s ease;
}

#cdfsolo8-header .cdfsolo8-brand:hover .cdfsolo8-logo {
  transform: translateY(-1px);
}

#cdfsolo8-header .cdfsolo8-logo-dark {
  display: none;
}

#cdfsolo8-header.cdfsolo8-white .cdfsolo8-logo-light {
  display: none;
}

#cdfsolo8-header.cdfsolo8-white .cdfsolo8-logo-dark {
  display: block;
}

.cdf-contact-button {
  min-width: 190px;
  height: 52px;
  min-height: 52px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 10px;

  flex: 0 0 auto;

  padding: 0 21px !important;

  color: #ffffff !important;

  background: linear-gradient(
    135deg,
    #ff9417 0%,
    #f77a00 54%,
    #eb6800 100%
  ) !important;

  border: 1px solid rgba(255, 255, 255, 0.22) !important;
  border-radius: 12px !important;

  box-shadow: 0 9px 20px rgba(236, 103, 0, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.27) !important;

  font-family: var(--cdfsolo8-font, "Montserrat"), sans-serif;
  font-size: 14px;
  line-height: 1;
  font-weight: 800;

  text-decoration: none !important;
  white-space: nowrap;

  transition: transform 0.16s ease, filter 0.16s ease, box-shadow 0.16s ease;
}

.cdf-contact-button:hover {
  transform: translateY(-2px);
  filter: brightness(1.04);

  box-shadow: 0 12px 24px rgba(236, 103, 0, 0.29),
    inset 0 1px 0 rgba(255, 255, 255, 0.3) !important;
}

.cdf-contact-button .cdfsolo8-wa {
  width: 22px;
  height: 22px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  flex: 0 0 22px;
}

.cdf-contact-button .cdfsolo8-wa svg {
  width: 100%;
  height: 100%;

  display: block;

  fill: #ffffff !important;
}

.cdf-contact-button .cdfsolo8-arrow {
  width: 16px;
  height: 16px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  flex: 0 0 16px;

  margin-left: 2px;
}

.cdf-contact-button .cdfsolo8-arrow svg {
  width: 100%;
  height: 100%;

  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

@media (max-width: 1100px) {
  #cdfsolo8-header {
    height: 72px !important;
    min-height: 72px !important;
  }

  #cdfsolo8-header .cdfsolo8-inner {
    width: calc(100% - 30px);

    height: 72px;
    min-height: 72px;

    gap: 16px;
  }

  #cdfsolo8-header .cdfsolo8-brand::after {
    display: none;
  }

  #cdfsolo8-header .cdfsolo8-brand:hover .cdfsolo8-logo {
    transform: none;
  }

  #cdfsolo8-header .cdfsolo8-logo {
    width: 275px;
    height: 56px;
  }

  .cdf-contact-button {
    min-width: 165px;
    height: 48px;
    min-height: 48px;

    padding: 0 16px !important;

    font-size: 13px;
  }

  .cdf-contact-button .cdfsolo8-wa {
    width: 20px;
    height: 20px;
    flex-basis: 20px;
  }
}

@media (max-width: 600px) {
  #cdfsolo8-header {
    height: 66px !important;
    min-height: 66px !important;
  }

  #cdfsolo8-header .cdfsolo8-inner {
    width: calc(100% - 18px);

    height: 66px;
    min-height: 66px;

    gap: 9px;
  }

  #cdfsolo8-header .cdfsolo8-brand {
    flex: 1 1 auto;
    min-width: 0;
  }

  #cdfsolo8-header .cdfsolo8-logo {
    width: 205px;
    height: 48px;
  }

  .cdf-contact-button {
    min-width: 0;

    height: 43px;
    min-height: 43px;

    gap: 6px;

    padding: 0 12px !important;

    border-radius: 10px !important;

    font-size: 11px;
  }

  .cdf-contact-button .cdfsolo8-wa {
    width: 18px;
    height: 18px;
    flex-basis: 18px;
  }

  .cdf-contact-button .cdfsolo8-arrow {
    display: none;
  }
}

@media (max-width: 440px) {
  #cdfsolo8-header .cdfsolo8-logo {
    width: 185px;
    height: 45px;
  }

  .cdf-contact-button {
    padding: 0 10px !important;
    font-size: 10px;
  }
}

@media (max-width: 370px) {
  #cdfsolo8-header .cdfsolo8-logo {
    width: 165px;
    height: 42px;
  }

  .cdf-contact-button {
    padding: 0 8px !important;
    font-size: 9px;
  }

  .cdf-contact-button .cdfsolo8-wa {
    width: 17px;
    height: 17px;
    flex-basis: 17px;
  }
}

#cdfsolo8-header-space {
  width: 100%;
  height: 86px;
  min-height: 86px;

  display: block;

  margin: 0;
  padding: 0;

  pointer-events: none;
}

@media (max-width: 1100px) {
  #cdfsolo8-header-space {
    height: 72px;
    min-height: 72px;
  }
}

@media (max-width: 600px) {
  #cdfsolo8-header-space {
    height: 66px;
    min-height: 66px;
  }
}

body.elementor-editor-active #cdfsolo8-header-space,
html.elementor-editor-active #cdfsolo8-header-space {
  display: none;
}

#cdfsolo8-header.cdfsolo8-editor {
  position: relative !important;

  top: auto !important;
  left: auto !important;
  right: auto !important;

  background: linear-gradient(
    108deg,
    #021a2b 0%,
    #03243a 34%,
    #063651 72%,
    #052a42 100%
  ) !important;

  transform: none !important;
  opacity: 1 !important;
  pointer-events: auto !important;
}

@media (prefers-reduced-motion: reduce) {
  #cdfsolo8-header,
  #cdfsolo8-header * {
    animation: none !important;
    transition: none !important;
  }
}

body.cdfhdrx-scroll-lock {
  overflow: hidden;
}

#cdfhdrx-wa-modal,
#cdfhdrx-wa-modal *,
#cdfhdrx-wa-modal *::before,
#cdfhdrx-wa-modal *::after {
  box-sizing: border-box;
}

#cdfhdrx-wa-modal {
  position: fixed;
  inset: 0;
  z-index: 999999;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 24px;

  font-family: "Montserrat", system-ui, -apple-system, BlinkMacSystemFont,
    "Segoe UI", sans-serif;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;

  transition: opacity 0.24s ease, visibility 0.24s ease;
}

#cdfhdrx-wa-modal.cdfhdrx-modal-open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

#cdfhdrx-wa-modal .cdfhdrx-modal-backdrop {
  position: absolute;
  inset: 0;

  background: rgba(0, 20, 42, 0.78);

  -webkit-backdrop-filter: blur(7px);
  backdrop-filter: blur(7px);
}

#cdfhdrx-wa-modal .cdfhdrx-modal-dialog {
  position: relative;
  z-index: 2;

  width: min(96vw, 1240px);
  max-height: 92svh;

  overflow: auto;

  padding: 40px 38px 34px;

  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 28px;

  color: #ffffff;

  background: radial-gradient(
      circle at 12% 5%,
      rgba(31, 135, 255, 0.16),
      transparent 28%
    ),
    linear-gradient(145deg, #0a4a8d 0%, #073f79 48%, #063564 100%);

  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.44);

  transform: translateY(18px) scale(0.985);

  transition: transform 0.28s cubic-bezier(0.16, 1, 0.3, 1);
}

#cdfhdrx-wa-modal.cdfhdrx-modal-open .cdfhdrx-modal-dialog {
  transform: translateY(0) scale(1);
}

#cdfhdrx-wa-modal .cdfhdrx-modal-close {
  position: absolute;
  top: 17px;
  right: 17px;

  width: 46px;
  height: 46px;

  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 50%;

  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);

  cursor: pointer;

  transition: transform 0.2s ease, background 0.2s ease;
}

#cdfhdrx-wa-modal .cdfhdrx-modal-close:hover {
  transform: scale(1.05);
  background: rgba(255, 255, 255, 0.18);
}

#cdfhdrx-wa-modal .cdfhdrx-modal-close svg {
  width: 23px;
  height: 23px;

  display: block;

  fill: none;
  stroke: currentColor;

  stroke-width: 2.2;
  stroke-linecap: round;
}

#cdfhdrx-wa-modal .cdfhdrx-modal-kicker {
  margin: 0 0 8px;

  color: #64c9ff;

  font-size: 15px;
  line-height: 1.2;
  font-weight: 900;

  letter-spacing: 0.08em;

  text-align: center;
  text-transform: uppercase;
}

#cdfhdrx-wa-modal .cdfhdrx-modal-title {
  width: 100%;
  max-width: 860px;

  margin: 0 auto 10px;

  color: #ffffff;

  font-size: clamp(32px, 3.35vw, 48px);
  line-height: 1.08;
  font-weight: 900;

  letter-spacing: -0.04em;

  text-align: center;
  text-wrap: balance;
}

#cdfhdrx-wa-modal .cdfhdrx-modal-description {
  width: 100%;
  max-width: 760px;

  margin: 0 auto 30px;

  color: rgba(255, 255, 255, 0.9);

  font-size: 18px;
  line-height: 1.5;
  font-weight: 500;

  text-align: center;
  text-wrap: balance;
}

#cdfhdrx-wa-modal .cdfhdrx-country-grid {
  display: grid;

  grid-template-columns: repeat(3, minmax(0, 1fr));

  gap: 18px;

  width: 100%;
  max-width: 1120px;

  margin: 0 auto;
  padding: 0;
}

#cdfhdrx-wa-modal .cdfhdrx-country-card {
  position: relative;
  isolation: isolate;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  min-width: 0;
  min-height: 118px;

  padding: 18px;

  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 22px;

  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;

  text-align: center;
  text-decoration: none !important;

  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);

  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease,
    border-color 0.18s ease;
}

#cdfhdrx-wa-modal .cdfhdrx-country-card::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;

  pointer-events: none;

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.07),
    rgba(255, 255, 255, 0) 42%
  );
}

#cdfhdrx-wa-modal .cdfhdrx-country-card--peru {
  background-color: #8e2a5a;

  background-image: linear-gradient(
    135deg,
    #a23868 0%,
    #8e2a5a 58%,
    #742145 100%
  );
}

#cdfhdrx-wa-modal .cdfhdrx-country-card--panama {
  background-color: #007bbf;

  background-image: linear-gradient(
    135deg,
    #1493d9 0%,
    #007bbf 58%,
    #005e93 100%
  );
}

#cdfhdrx-wa-modal .cdfhdrx-country-card--venezuela {
  background-color: #444444;

  background-image: linear-gradient(
    135deg,
    #5a5a5a 0%,
    #444444 58%,
    #2f2f2f 100%
  );
}

#cdfhdrx-wa-modal .cdfhdrx-country-shine {
  position: absolute;
  inset: 0;
  z-index: 1;

  border-radius: inherit;
  pointer-events: none;

  background: linear-gradient(
    110deg,
    transparent 0%,
    rgba(255, 255, 255, 0) 34%,
    rgba(255, 255, 255, 0.14) 48%,
    rgba(255, 255, 255, 0.05) 54%,
    transparent 66%
  );

  transform: translateX(-120%) skewX(-12deg);

  animation: cdfPopupShine 4.8s ease-in-out infinite;
}

@keyframes cdfPopupShine {
  0% {
    transform: translateX(-120%) skewX(-12deg);

    opacity: 0;
  }

  18% {
    opacity: 0.72;
  }

  46% {
    transform: translateX(120%) skewX(-12deg);

    opacity: 0;
  }

  100% {
    transform: translateX(120%) skewX(-12deg);

    opacity: 0;
  }
}

#cdfhdrx-wa-modal .cdfhdrx-country-card:hover {
  transform: translateY(-3px);

  filter: saturate(1.05);

  border-color: rgba(255, 255, 255, 0.24);

  box-shadow: 0 18px 38px rgba(0, 0, 0, 0.28);
}

#cdfhdrx-wa-modal .cdfhdrx-country-info {
  position: relative;
  z-index: 2;

  display: grid;

  grid-template-columns: 28px auto;
  grid-template-rows: auto auto;

  align-items: center;
  justify-content: center;
  justify-items: start;

  column-gap: 12px;
  row-gap: 10px;

  width: max-content;
  max-width: 100%;

  margin: 0 auto;

  text-align: left;
}

#cdfhdrx-wa-modal .cdfhdrx-country-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;
}

#cdfhdrx-wa-modal .cdfhdrx-country-icon img {
  display: block;

  width: 100%;
  height: 100%;

  object-fit: contain;

  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.18));
}

#cdfhdrx-wa-modal .cdfhdrx-country-name {
  justify-self: start;

  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;

  font-size: 20px;
  line-height: 1.08;
  font-weight: 900;

  letter-spacing: 0.2px;

  white-space: nowrap;
}

#cdfhdrx-wa-modal .cdfhdrx-country-phone {
  justify-self: start;

  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;

  font-size: 17px;
  line-height: 1.12;
  font-weight: 700;

  letter-spacing: 0.2px;

  white-space: nowrap;
}

#cdfhdrx-wa-modal .cdfhdrx-country-card:focus-visible,
#cdfhdrx-wa-modal .cdfhdrx-modal-close:focus-visible {
  outline: 3px solid #ffffff;
  outline-offset: 4px;
}

@media (min-width: 641px) and (max-width: 991px) {
  #cdfhdrx-wa-modal .cdfhdrx-modal-dialog {
    width: min(96vw, 820px);

    padding: 38px 28px 30px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-grid .cdfhdrx-country-card:last-child {
    grid-column: 1 / -1;

    width: 100%;
    max-width: 420px;

    margin: 0 auto;
  }
}

@media (max-width: 640px) {
  #cdfhdrx-wa-modal {
    padding: 12px 10px;

    align-items: center;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-dialog {
    width: min(100%, 390px);
    max-height: calc(100svh - 24px);

    padding: 30px 12px 14px;

    border-radius: 20px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-close {
    top: 9px;
    right: 9px;

    width: 34px;
    height: 34px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-close svg {
    width: 19px;
    height: 19px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-kicker {
    max-width: 270px;

    margin: 0 auto 5px;

    font-size: 10px;
    line-height: 1.18;
    letter-spacing: 0.065em;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-title {
    max-width: 320px;

    margin-bottom: 7px;

    font-size: 24px;
    line-height: 1.08;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-description {
    max-width: 315px;

    margin-bottom: 15px;

    font-size: 13px;
    line-height: 1.38;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-grid {
    grid-template-columns: 1fr;

    gap: 10px;

    width: 100%;
    max-width: 330px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-grid .cdfhdrx-country-card:last-child {
    grid-column: auto;

    width: 100%;
    max-width: none;

    margin: 0;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-card {
    min-height: 84px;

    padding: 12px 14px;

    border-radius: 16px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-info {
    grid-template-columns: 23px auto;

    column-gap: 9px;
    row-gap: 6px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-icon {
    width: 20px;
    height: 20px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-name {
    font-size: 16px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-phone {
    font-size: 14px;
  }
}

@media (max-width: 360px) {
  #cdfhdrx-wa-modal {
    padding: 8px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-dialog {
    width: min(100%, 342px);
    max-height: calc(100svh - 16px);

    padding: 28px 9px 11px;

    border-radius: 18px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-close {
    width: 31px;
    height: 31px;

    top: 7px;
    right: 7px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-kicker {
    max-width: 235px;

    font-size: 9px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-title {
    max-width: 285px;

    font-size: 21px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-modal-description {
    max-width: 280px;

    margin-bottom: 12px;

    font-size: 12px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-grid {
    max-width: 300px;

    gap: 8px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-card {
    min-height: 76px;

    padding: 10px 12px;

    border-radius: 15px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-name {
    font-size: 15px;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-phone {
    font-size: 13px;
  }
}

@media (prefers-reduced-motion: reduce) {
  #cdf-hero-giro-final-v2 *,
  #cdf-hero-giro-final-v2 *::before,
  #cdf-hero-giro-final-v2 *::after {
    animation: none !important;
    transition: none !important;
  }

  #cdfhdrx-wa-modal,
  #cdfhdrx-wa-modal .cdfhdrx-modal-dialog,
  #cdfhdrx-wa-modal .cdfhdrx-country-card {
    transition: none !important;
  }

  #cdfhdrx-wa-modal .cdfhdrx-country-shine {
    animation: none !important;
  }
}

#cdfsolo8-header .cdfhdrx-wa-launch {
  cursor: pointer;
}
</style>
